/*const root='/portal';*/
const root = "/abfa-mazandaran/EServices";
export {root}